// extracted by mini-css-extract-plugin
module.exports = {"watium4":"watium4"};